import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public readonly isDarkMode = signal<boolean>(false);

  constructor() {
    const savedDarkMode = localStorage.getItem('darkMode');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialDarkMode = savedDarkMode ? JSON.parse(savedDarkMode) : prefersDark;

    this.isDarkMode.set(initialDarkMode);

    effect(() => {
      this.applyTheme(this.isDarkMode());
    });
  }

  public toggleTheme(): void {
    this.isDarkMode.update((current: any) => !current);
  }

  private applyTheme(isDark: boolean): void {
    if (isDark) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }

    localStorage.setItem('darkMode', JSON.stringify(isDark));
  }
}
